module.exports = {
  THEME_DARK: 'theme.dark',
  INVOICE_BANKGIRO: 'invoice.bankgiro',
  INVOICE_PLUSGIRO: 'invoice.plusgiro',
  SESSION_TIMEOUT: 'session.timeout',
}
